// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './app/environments/environment';

// if (environment.production) {
//   enableProdMode();
//   if (window) {
//     window.console.log = () => { }
//     window.console.error = () => { }
//     window.console.warn = () => { }
//     window.console.info = () => { }
//     window.console.clear = () => { }
//   }
// } else {
//   // if (window) {
//   //   window.console.log = () => { }
//   //   window.console.error = () => { }
//   //   window.console.warn = () => { }
//   //   window.console.info = () => { }
//   //   window.console.clear = () => { }
//   // }
// }


// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
import { enableProdMode } from '@angular/core';
import { environment } from './app/environments/environment';
 import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
fetch('./assets/config.json')
  .then(response => response.json())
  .then(config => {
    Object.assign(environment, config);
    console.log('environment: ', environment);
 
    if (environment.production) {
      enableProdMode();
      if (window) {
        window.console.log = () => {};
        window.console.error = () => {};
        window.console.warn = () => {};
        window.console.info = () => {};
        window.console.clear = () => {};
      }
    }
 
    return import('./app/app.module');
  })
  .then(({ AppModule }) => {
   
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err: any) => console.error(err));
  })
  .catch(err => {
    console.error('Failed to load runtime config. Bootstrapping with default environment.ts', err);
    import('./app/app.module').then(({ AppModule }) => {
      platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((err: any) => console.error(err));
    });
  });
 
 